import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import { t } from 'i18next';

import LABELS_API from './labels.api';
import { MESSAGE_MASTER } from 'src/shared/constants/message';

export const getLabelsAction = createAsyncThunk<any, LabelsStore.RequestData>(
  'labels',
  async ({ data, callback = () => {} }, { dispatch, rejectWithValue }) => {
    try {
      const response = await LABELS_API.getLabelsAPI({
        page: data?.page,
        size: data?.size,
        terminalId: data?.terminalId,
        haveLabel: data?.haveLabel,
      });
      callback();
      return { response, isSubmit: data?.isSubmit };
    } catch (err: any) {
      notification.error({ message: t(`errorMsg.${err?.code || 0}`) });

      rejectWithValue(err?.message);
    }
  },
);

export const createLabelAction = createAsyncThunk<any, LabelsStore.RequestData>(
  'create_Labels',
  async ({ data, callback = () => {} }, { dispatch, rejectWithValue }) => {
    try {
      await LABELS_API.createLabelAPI(data);
      callback();
      notification.success({ message: MESSAGE_MASTER.COMMON.CREATE_SUCCESSFULLY });
      return data;
    } catch (err: any) {
      notification.error({ message: t(`errorMsg.${err?.code || 0}`) });

      return rejectWithValue(err?.message);
    }
  },
);

export const updateLabelAction = createAsyncThunk<any, LabelsStore.RequestData>(
  'update_Labels',
  async ({ data, callback = () => {} }, { dispatch, rejectWithValue }) => {
    try {
      const response = await LABELS_API.updateLabelsAPI(data);
      notification.success({ message: MESSAGE_MASTER.COMMON.EDIT_SUCCESSFULLY });
      callback();

      return response;
    } catch (err: any) {
      notification.error({ message: t(`errorMsg.${err?.code || 0}`) });

      return rejectWithValue(err?.message);
    }
  },
);

export const deleteLabelActions = createAsyncThunk<any, LabelsStore.RequestDeleteLabels>(
  'delete_Labels',
  async ({ id, callback = () => {} }, { dispatch, rejectWithValue }) => {
    try {
      const response = await LABELS_API.deleteLabelAPI(id);
      callback();
      notification.success({ message: MESSAGE_MASTER.COMMON.DELETE_SUCCESSFULLY });

      return response;
    } catch (err: any) {
      notification.error({ message: t(`errorMsg.${err?.code || 0}`) });

      return rejectWithValue(err?.message);
    }
  },
);
